import { kebabCase } from 'lodash';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { ScheduleRangeType } from './enums';

export const useScheduleRangeTypeValues = () => {
  const intl = useIntl();

  const data = useMemo(
    () =>
      Object.values(ScheduleRangeType).map(option => ({
        key: option,
        title: intl.formatMessage({
          id: `common.schedule-range-type.${kebabCase(option)}`,
        }),
      })),
    [intl]
  );

  return {
    data,
    loading: false,
  };
};
